import React from 'react';
import './ModoToggle.css';

/**
 * Toggle de seleção de modo de análise.
 * Registro — rápido (~15s), causa raiz básica.
 * Investigação — completo (~40s), Ishikawa 6M, hipóteses, 5W2H.
 *
 * #161/#226 — gating de tier (flag-aware, vem do /auth/me):
 *  - investigacaoLiberada=false  → botão Investigação travado (cadeado +
 *    "A partir do Pro") com a copy de upsell do backend (bloqueioMotivo).
 *  - degustacaoDisponivel=true   → selo "1ª grátis" no botão Investigação.
 * Com a flag OFF, os defaults (liberada=true, degustacao=false) deixam a UI
 * idêntica à de hoje.
 */
function ModoToggle({
  value,
  onChange,
  disabled,
  investigacaoLiberada = true,
  degustacaoDisponivel = false,
  bloqueioMotivo,
}) {
  const investigacaoBloqueada = !investigacaoLiberada;
  const invDisabled = disabled || investigacaoBloqueada;

  return (
    <div className="modo-toggle">
      <span className="modo-toggle-label">Modo de Análise</span>

      <div className="modo-toggle-options">
        <button
          type="button"
          className={`modo-toggle-btn ${value === 'registro' ? 'active registro' : ''}`}
          onClick={() => !disabled && onChange('registro')}
          disabled={disabled}
          title="Análise básica: causa raiz, ação imediata e plano de ação"
        >
          <span className="modo-toggle-icon material-symbols-outlined" style={{ fontSize: '1.375rem' }}>assignment</span>
          <span className="modo-toggle-text">
            <strong>Registro</strong>
            <small>Análise rápida ~15s</small>
          </span>
        </button>

        <button
          type="button"
          className={`modo-toggle-btn ${value === 'investigacao' ? 'active investigacao' : ''} ${investigacaoBloqueada ? 'modo-bloqueado' : ''}`}
          onClick={() => !invDisabled && onChange('investigacao')}
          disabled={invDisabled}
          title={investigacaoBloqueada
            ? (bloqueioMotivo || 'Disponível a partir do plano Pro')
            : 'Investigação completa: Ishikawa 6M, 2 hipóteses, 5W2H, análise de recorrência'}
        >
          <span className="modo-toggle-icon material-symbols-outlined" style={{ fontSize: '1.375rem' }}>
            {investigacaoBloqueada ? 'lock' : 'biotech'}
          </span>
          <span className="modo-toggle-text">
            <strong>
              Investigação
              {degustacaoDisponivel && <span className="modo-badge modo-badge-gratis">1ª grátis</span>}
              {investigacaoBloqueada && <span className="modo-badge modo-badge-pro">Pro</span>}
            </strong>
            <small>{investigacaoBloqueada ? 'A partir do Pro' : 'Análise completa ~40s'}</small>
            {!investigacaoBloqueada && (
              <span style={{ fontSize: '0.65rem', color: 'var(--on-secondary-container, #57657a)', marginTop: '2px', display: 'block', lineHeight: 1.3 }}>
                Ishikawa 6M · Hipótese alt. · 5W2H
              </span>
            )}
          </span>
        </button>
      </div>

      {investigacaoBloqueada ? (
        <p className="modo-toggle-hint modo-toggle-hint-upsell">
          {bloqueioMotivo || 'A Investigação completa está disponível a partir do plano Pro.'}
        </p>
      ) : degustacaoDisponivel ? (
        <p className="modo-toggle-hint modo-toggle-hint-degustacao">
          🎁 Sua primeira Investigação completa é por nossa conta — sem custo.
        </p>
      ) : (
        <p className="modo-toggle-hint">
          {value === 'investigacao'
            ? 'Ishikawa 6M · 2 hipóteses de causa raiz · 5W2H · Análise de recorrência'
            : 'Causa raiz · 5 Porquês · Ação imediata · Plano básico'}
        </p>
      )}
    </div>
  );
}

export default ModoToggle;
